import { render } from "./NoraUitgelichtModal.vue?vue&type=template&id=5740854a"
import script from "./NoraUitgelichtModal.vue?vue&type=script&lang=js"
export * from "./NoraUitgelichtModal.vue?vue&type=script&lang=js"

import "./NoraUitgelichtModal.vue?vue&type=style&index=0&id=5740854a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__